// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wNg3","col":"styles_col__1X26o"};